import snakeCase from 'lodash/snakeCase';
import {
  calculateLabelStep,
  formatLabelDate,
  removeLongShortSuffixFromChartName,
  customStackedColumnChartBAnchorColors,
  buildDataSet,
  multiplierCalculator
} from 'utils/widget-helpers';

export const defaultChartDataSource = (data, widget) => {
  const { chartSchema } = data || {};
  const { isLegendDisplayed, isChartTooltipDisplayed, overlay, colSpan } = widget;
  const { widgetTitle } = overlay;

  const y2AxisSeriesNames = chartSchema && chartSchema.find(item => item.axis === 'Y2');
  const { suffix: y2Suffix } = (y2AxisSeriesNames && y2AxisSeriesNames) || {};
  const yAxis = chartSchema && chartSchema.find(item => item.axis === 'Y');
  const { suffix } = yAxis || {};

  const numberOfLegendRows = data.datasets.length > 4 ? 2 : 1;

  const hasValidCategories = data.categories && data.categories.length > 0;
  const categoriesLength = hasValidCategories && data.categories.length;
  const labelStepValue = hasValidCategories && calculateLabelStep(categoriesLength, colSpan);

  const dataSource = data && {
    chart: {
      //TODO: to fix the anchors for overlay 2000003
      anchorBgColor: "#346C9F",
      anchorRadius: "6",
      yAxisName: data.chartSchema.find(schema => schema.axis === 'Y')?.name || null,
      xAxisName: data.chartSchema.find(schema => schema.axis === 'X')?.name || null,
      // sYAxisName : y2AxisSeriesNames && y2AxisSeriesNames.name,
      ...(widget.overlay.publicId == 2000003  ? {lineAlpha: "1"} : {}),
      showValues: false,
      showAnchors: widget.overlay.publicId == 2000003 ? true : false,
      // numberSuffix: '%',
      // yAxisValueDecimals: '0',
      formatNumberScale: true,
      numberPrefix: suffix === '$' && '$',
      numberScaleValue: suffix === '$' ? '1' : '.01',
      numberScaleUnit: (suffix === '$' || suffix === '#') ? '' : '%',
      forceNumberScale: true,
      forceDecimals: false,
      // decimals: 5,
      // TODO: Use the chart schema to format the dollar and percent values for both Y axes natively with FC options

      // sNumberPrefix: y2AxisSeriesNames && '$',
      sNumberPrefix: y2Suffix === '$' && '$',
      // sNumberSuffix: y2AxisSeriesNames && '%',
      sNumberScaleValue: y2AxisSeriesNames && y2Suffix === '$' ? '1' : '.01',
      sNumberScaleUnit: y2AxisSeriesNames && y2Suffix === '$' ? '' : '%',
      showToolTip: isChartTooltipDisplayed,
      plotHighlightEffect: 'fadeout',
      theme: 'fusion',
      exportEnabled: true,
      exportFormats: 'PNG|PDF|CSV|SVG',

      // Labels configuration start here
      rotateLabels: '0',
      useEllipsesWhenOverflow: true,
      labelStep: labelStepValue,
      // labelBinSize: '0',
      // plotBinSize: 2,
      // labelFontSize: '13',
      // labelDisplay: 'stagger',
      // staggerLines: '1',
      // maxLabelHeight: '25',
      // maxLabelWidthPercent: '60',
      // labelDisplay: 'wrap',

      // Labels configuration ends here ^

      // exportMode: 'server',
      setAdaptiveYMin: true,
      adjustDiv: true,

      sFormatNumberScale: !!y2AxisSeriesNames,
      sForceNumberScale: true,
      // stack100Percent: true,
      // plotSpacePercent: 0,
      exportFileName: widgetTitle && snakeCase(widgetTitle),
      exportShowMenuItem: false,
      showSecondaryLimits: !!y2AxisSeriesNames,
      showDivLineSecondaryValue: !!y2AxisSeriesNames,
      showLegend: isLegendDisplayed,
      connectNullData: true,
      trendLineAlpha: data.standardDeviation && '10',
      trendValueAlpha: data.standardDeviation && '100',

      // TODO: Custom function or logic for the number of rows depending on the number of datasets in order to limit the space the legend is taking from the chart/graph
      legendNumRows: numberOfLegendRows,
      // legendPosition: 'bottom-left',
      // legendAllowDrag: '1',
      legendItemFontSize: '12',
      minimiseWrappingInLegend: true,
      alignLegendWithCanvas: false,
      crossLineAnimation: '0',
      chartLeftMargin: '1',
      chartTopMargin: '16',
      chartRightMargin: '0',
      chartBottomMargin: '0',
      yAxisMinValue: 0
    },
    categories: [
      {
        category:
          data.categories.length > 0 &&
          data.categories.map(category => ({
            label: formatLabelDate(category.label)
          }))
      }
    ],
    dataset: [
      ...data.datasets.map(dataset => ({
        seriesName: removeLongShortSuffixFromChartName(dataset.name),
        renderAs: dataset.type,
        parentYAxis:
          y2AxisSeriesNames && y2AxisSeriesNames.timeSeriesNames.includes(dataset.name) ? 'S' : 'Y',
        data:
          dataset.data.length > 0 &&
          dataset.data.map(item => ({
            value: item.value
          }))
      }))
    ],
    trendLines: data.standardDeviation && [
      {
        line: [
          {
            isTrendZone: true,
            startValue: data.standardDeviation.min / 100,
            endValue: data.standardDeviation.max / 100,
            color: '#212344',
            // valueOnRight: true,
            // tooltext: 'Standart Diviation'
            // See the difference between $startValue and $startDataValue: https://www.fusioncharts.com/dev/chart-guide/chart-configurations/tool-tips#example-1-tooltip-macros-for-trend-lines
            // toolText: 'Standard Deviation range from $startDataValue  to $endDataValue',
            displayValue: ' '
          }
        ]
      }
    ]
  };
  return dataSource;
};

export const pieChartDataSource = (data, widget) => {
  const { isLegendDisplayed, isChartTooltipDisplayed, overlay } = widget;
  const { widgetTitle } = overlay;

  const dataSource = {
    chart: {
      theme: 'fusion',
      showToolTip: isChartTooltipDisplayed,
      showLegend: isLegendDisplayed,
      exportShowMenuItem: false,
      exportFileName: widgetTitle && snakeCase(widgetTitle),
      exportEnabled: true,
      exportFormats: 'PNG|PDF|CSV|SVG'
    },
    data: data.datasets.map(dataset => ({
      value: dataset.data[0].value,
      label: dataset.name,
      tooltext: dataset.data[0].toolTip
    }))
  };
  return dataSource;
};

export const customStackedColumnChartB = (data, widget) => {
  const { isLegendDisplayed, isChartTooltipDisplayed, overlay } = widget;
  const { widgetTitle } = overlay;
  const { chartSchema } = data;
  const yAxis = chartSchema[1];
  const multiplier = multiplierCalculator(yAxis.suffix);
  const filterNull = value => {
    return value.value !== null
      ? { value: value.value * multiplier, toolText: value.toolText }
      : null;
  };

  const dataSource = {
    chart: {
      theme: 'fusion',
      showToolTip: isChartTooltipDisplayed,
      showLegend: isLegendDisplayed,
      exportShowMenuItem: false,
      numbersuffix: yAxis.suffix,
      exportFileName: widgetTitle && snakeCase(widgetTitle),
      exportEnabled: true,
      exportFormats: 'PNG|PDF|CSV|SVG'
    },
    categories: [
      {
        category:
          data.categories.length > 0 &&
          data.categories.map(category => ({
            label: category.label
          }))
      }
    ],
    dataset: data.datasets.map((dataset, index) => ({
      data: dataset.data.filter(filterNull),
      seriesName: dataset.name && dataset.name,
      renderAs: 'line',
      alpha: 0,
      ...customStackedColumnChartBAnchorColors(index)
    }))
  };

  const quartileEntries = data.quartileEntries.map(qe => ({
    data: qe.sections.map(d => ({ min: d.maxValue * multiplier, max: d.minValue * multiplier }))
  }));

  dataSource.dataset = dataSource.dataset.concat(buildDataSet(quartileEntries));

  return dataSource;
};

export const scatterChartDataSource = (data, widget) => {
  const { isLegendDisplayed, isChartTooltipDisplayed, overlay } = widget;
  const { widgetTitle } = overlay;

  const dataSource = {
    chart: {
      yAxisName: 'Period Values',
      xAxisName: 'Dates',
      theme: 'fusion',
      numberSuffix: '%',
      showToolTip: isChartTooltipDisplayed,
      showLegend: isLegendDisplayed,
      exportShowMenuItem: false,
      exportFileName: widgetTitle && snakeCase(widgetTitle),
      exportEnabled: true,
      exportFormats: 'PNG|PDF|CSV|SVG'
    },

    dataset: data.datasets.map(dataset => ({
      seriesname: dataset.name,
      showRegressionLine: '1',
      data: dataset.data.map(item => ({
        x: item.value.x * 100,
        y: item.value.y * 100
      }))
    }))
  };
  return dataSource;
};

export const bubbleChartDataSource = (data, widget) => {
  const { isLegendDisplayed, isChartTooltipDisplayed, overlay } = widget;
  const { widgetTitle } = overlay;
  const { categories, datasets } = data;
  const bubbleData =
    data &&
    categories &&
    datasets &&
    categories.map((category, index) => ({
      name: category.label,
      x: datasets[0].data[index].value,
      y: datasets[1].data[index].value,
      z: datasets[2].data[index].value
    }));

  const dataSource = data && {
    chart: {
      yAxisName: datasets[1].name,
      xAxisName: datasets[0].name,
      theme: 'fusion',
      numberSuffix: '%',
      plotFillHoverColor: '#346C9F',
      plotTooltext:
        '$name : Marginal Return: $xValue%; Risk Weight: $yValue%; Allocation: $zValue%',
      showToolTip: isChartTooltipDisplayed,
      showLegend: isLegendDisplayed,
      exportShowMenuItem: false,
      exportFileName: widgetTitle && snakeCase(widgetTitle),
      exportEnabled: true,
      exportFormats: 'PNG|PDF|CSV|SVG',
      canvasTopPadding: '40',
      canvasBottomPadding: '40'
    },

    dataset: [
      {
        showRegressionLine: '1',
        regressionLineColor: '#7e7e7e',
        data: bubbleData.map(item => ({
          x: item.x,
          y: item.y,
          z: item.z,
          name: item.name
        }))
      }
    ]
  };

  return dataSource;
};

export const strategyExposureChart = (data, widget) => {
  const dataSource = defaultChartDataSource(data, widget);
  const axisProps = {
    yAxisMaxValue: 1.0,
    yAxisMinValue: 0.0,
    showLimits: 1
  };
  dataSource.chart = { ...dataSource.chart, ...axisProps };
  return dataSource;
};
